import { render, staticRenderFns } from "./shakePage.vue?vue&type=template&id=404aa6c6&"
import script from "./shakePage.vue?vue&type=script&lang=js&"
export * from "./shakePage.vue?vue&type=script&lang=js&"
import style0 from "./shakePage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports